import React, { useState } from "react";
import { Typography, Box, Modal, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { AiOutlineEye } from "react-icons/ai";
import styles from "./PayoutListing.module.css";

const formatAmount = (amount) => {
  const abs = Math.abs(amount).toFixed(2);
  return amount < 0 ? `-$${abs}` : `$${abs}`;
};

const formatDate = (rawDate) => {
  const date = new Date(rawDate);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("default", { month: "short" });
  const year = String(date.getFullYear()).slice(-2);
  return `${day}. ${month}. ${year}`;
};

const PayoutListing = ({ id, name, date, type, amount, fee, status }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const getStatusClass = (status) => {
    switch (status.toLowerCase()) {
      case 'initialised': return styles.initialised;
      case 'pending': return styles.pending;
      case 'send': return styles.send;
      case 'completed': return styles.completed;
      default: return styles.unknown;
    }
  };

  return (
    <>
      <Box className={styles.payoutListing}>
        <Typography className={styles.name}>{name}</Typography>
        <Typography className={styles.fixedWidth}>{formatDate(date)}</Typography>
        <Typography className={styles.fixedWidth}>{type}</Typography>
        <Typography className={styles.fixedWidth}>{formatAmount(amount)}</Typography>
        <Typography className={styles.fixedWidth}>{formatAmount(fee)}</Typography>
        <Box className={`${styles.fixedWidth} ${styles.statusBox} ${getStatusClass(status)}`}>
          {status}
        </Box>
        <Tooltip title="View details" arrow>
          <Typography className={styles.more} onClick={handleOpen}>
            <AiOutlineEye />
          </Typography>
        </Tooltip>
      </Box>

      <Modal open={open} onClose={handleClose}>
        <Box className={styles.modalBackdrop}>
          <Box className={styles.modalContent}>
            <Typography variant="h6" className={styles.modalTitle}>Payout Details</Typography>

            <Box className={styles.modalSection}>
              <Typography className={styles.modalLabel}><strong>ID:</strong></Typography>
              <Typography className={styles.modalValue}>{id}</Typography>
            </Box>

            <Box className={styles.modalSection}>
              <Typography className={styles.modalLabel}><strong>Name:</strong></Typography>
              <Typography className={styles.modalValue}>{name}</Typography>
            </Box>

            <Box className={styles.modalSection}>
              <Typography className={styles.modalLabel}><strong>Date:</strong></Typography>
              <Typography className={styles.modalValue}>{formatDate(date)}</Typography>
            </Box>

            <Box className={styles.modalSection}>
              <Typography className={styles.modalLabel}><strong>Type:</strong></Typography>
              <Typography className={styles.modalValue}>{type}</Typography>
            </Box>

            <Box className={styles.modalSection}>
              <Typography className={styles.modalLabel}><strong>Amount:</strong></Typography>
              <Typography className={styles.modalValue}>{formatAmount(amount)}</Typography>
            </Box>

            <Box className={styles.modalSection}>
              <Typography className={styles.modalLabel}><strong>Fee:</strong></Typography>
              <Typography className={styles.modalValue}>{formatAmount(fee)}</Typography>
            </Box>

            <Box className={styles.modalSection}>
              <Typography className={styles.modalLabel}><strong>Status:</strong></Typography>
              <Typography className={styles.modalValue}>{status}</Typography>
            </Box>

            <Box className={styles.modalFooter}>
              <Typography className={styles.closeButton} onClick={handleClose}>Close</Typography>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

PayoutListing.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  fee: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
};

export default PayoutListing;